
<template v-if="sidebarComponents.length === 0">
  <section
    v-if="variants.v1 === variant"
    class="n-section-primary tw-relative"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div
      class="tw-mb-10 tw-flex tw-flex-col tw-items-start tw-gap-3 tw-self-start tw-text-start md:tw-items-center md:tw-self-center md:tw-text-center lg:tw-mb-16"
    >
      <small v-if="vars.altTitleText"> {{ vars.altTitleText }}</small>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        :loop="true"
        effect="fade"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 24,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          :delay="index * 250"
        >
          <Theme6BlogsBlogCard :blog="blog" :index="index" :component="component" />
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v4"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="vars.buttonLabelText"
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-10 tw-self-center`"
      :to="ROUTES.BLOGS"
    >
      <div class="n-btn-container">
        <div class="n-btn-group">
          <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
        </div>
      </div>
    </nuxt-link>
  </section>

  <section
    v-if="variants.v2 === variant"
    class="n-section-primary tw-relative"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-mb-8 tw-flex tw-flex-col tw-items-center tw-gap-3 tw-self-center tw-text-center lg:tw-mb-12">
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        effect="fade"
        :loop="true"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 48,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          :delay="index * 250"
        >
          <Theme6BlogsBlogCard :blog="blog" :index="index" :component="component" />
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v5"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="vars.buttonTypeText"
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-6 tw-self-center`"
      :to="ROUTES.BLOGS"
    >
      <div class="n-btn-container">
        <div class="n-btn-group">
          <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
        </div>
      </div>
    </nuxt-link>
  </section>

  <section
    v-if="variants.v3 === variant"
    class="n-section-primary tw-relative"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-mb-8 tw-flex tw-flex-col tw-items-center tw-gap-3 tw-self-center tw-text-center lg:tw-mb-12">
      <small v-if="vars.altTitleText"> {{ vars.altTitleText }}</small>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        effect="fade"
        :loop="true"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 48,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          :delay="index * 250"
        >
          <Theme6BlogsBlogCard :blog="blog" :index="index" :component="component" version="v3" />
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v5"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="vars.buttonTypeText"
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-6 tw-self-center`"
      :to="ROUTES.BLOGS"
    >
      <div class="n-btn-container">
        <div class="n-btn-group">
          <div class="n-btn-t1">{{ vars.buttonLabelText }}</div>
          <div class="n-btn-t2">{{ vars.buttonLabelText }}</div>
        </div>
      </div>
    </nuxt-link>
  </section>

   <section
    v-if="variants.v4 === variant"
    class="n-section-primary tw-relative"
    :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
  >
    <div class="tw-mb-8 tw-flex tw-flex-col tw-items-center tw-gap-3 tw-self-center tw-text-center lg:tw-mb-12">
      <h6 v-if="vars.altTitleText"> {{ vars.altTitleText }}</h6>
      <h2>{{ vars.titleText }}</h2>
    </div>
    <div v-if="isBlogsLoading">
      <loader loader-color="var(--c-primary)" />
    </div>
    <div class="tw-relative tw-w-full">
      <Swiper
        :modules="[SwiperPagination]"
        :slides-per-view="3"
        :space-between="30"
        effect="fade"
        :loop="true"
        :clickable="true"
        :breakpoints="{
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 32,
          },
          1336: {
            slidesPerView: 3,
            spaceBetween: 48,
          },
        }"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
        class="tw-w-full"
      >
        <SwiperSlide
          v-for="(blog, index) in blogs"
          :key="`blog-${index}`"
          class="tw-flex tw-items-center tw-justify-center"
          :delay="index * 250"
        >
          <Theme6BlogsBlogCard :blog="blog" :index="index" :component="component" version="v4" />
        </SwiperSlide>
      </Swiper>
      <LibrarySliderPagination
        :swiper="swiper"
        variant="v15"
        :can-paginate-back="canPaginateBack"
        :can-paginate-next="canPaginateNext"
      />
    </div>
    <nuxt-link
      v-if="vars.buttonTypeText"
      :external="true"
      :class="`n-${vars.buttonTypeText} n-btn tw-mt-6 tw-self-center`"
      :to="ROUTES.BLOGS"
    >
      {{ vars.buttonLabelText }}
    </nuxt-link>
  </section>


 
   

    <section
      v-if="sidebarComponents && sidebarComponents.length > 0 && variant === variants.v5"
      class="layout-pt-lg layout-pb-lg"
      :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
    >
      <div class="container">
        <div class="mb-8 tw-flex tw-items-center tw-justify-between">
          <!-- Başlık -->
          <h2 :style="`color: var(--c-${vars.textColor})`">{{ vars.titleText }}</h2>

          <!-- Buton -->
          <div class="tw-hidden md:tw-block">
            <nuxt-link
              v-for="(btn, idx) in buttons"
              :key="idx"
              :to="btn.link"
              :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${btn.button_type}`]"
              :external="true"
            >
              {{ btn.button_label }}
            </nuxt-link>
          </div>
        </div>

        <div v-if="isBlogsLoading">
          <loader loader-color="var(--c-primary)" />
        </div>

        <div
          class="mt-60 md:mt-40 sm:mt-20 js-section-slider tw-z-10"
          data-anim="slide-left delay-1"
          data-gap="30"
          data-slider-cols="xl-3 lg-2 md-1 sm-1 base-1"
        >
          <div class="swiper-wrapper tw-max-h-[580px] md:tw-max-h-none">
            <div class="swiper-slide" v-for="(blog, index) in blogs" :key="`latestblogs-blog-${index}`">
              <Theme7BlogsBlogCard :blog="blog" :index="index" version="v6" :component="component" />
            </div>
          </div>

          <div class="d-flex mt-60 md:mt-30 min-[1200px]:!tw-hidden">
            <button class="sliderNav -prev js-prev n-link !tw-bg-transparent !tw-text-white">
              <i class="icon-left-arrow"></i>
            </button>
            <button class="sliderNav -next ml-20 js-next n-link !tw-bg-transparent !tw-text-white">
              <i class="icon-right-arrow"></i>
            </button>
          </div>
          <div class="col-auto tw-mt-8 tw-flex tw-items-center md:tw-hidden">
            <nuxt-link
              v-for="(button, idx) in buttons"
              :key="idx"
              :to="button.button_link"
              :class="[buttons.length > 1 ? 'tw-w-full md:tw-w-auto' : 'tw-w-auto', `n-${button.button_type}`]"
              :external="true"
            >
              {{ button.button_label }}
            </nuxt-link>
          </div>
        </div>
      </div>
    </section>
  
  </template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import Loader from '~/components/common/Loader.vue';
export default defineNuxtComponent({
  name: 'Theme6OurBlog',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  components: {
    Loader,
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,

      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        v4: 'v4',
        v5: 'v5',
      },
    };
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    ROUTES() {
      return ROUTES;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>
